export const ru = {
    'confirm-delete': 'Вы уверены, что хотите удалить набор минус-фраз?',
    copy: 'Копия',
    'create-success': 'Набор минус-фраз «{name}» создан',
    'delete-error':
        'Во время удаления набора минус-фраз «{name}» произошла ошибка',
    'delete-success': 'Набор минус-фраз «{name}» удалён',
    'deleted-error': 'Во время удаления произошла ошибка',
    'deleted-success': 'Набор минус-фраз удален',
    'deleted-successful': 'Набор минус-фраз удален',
    'save-error': 'Во время сохранения произошла ошибка',
    'update-success': 'Набор минус-фраз «{name}» изменен'
};
